var _g, _g2, _g3, _g4, _g5, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReallot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 66 66",
    height: 512,
    viewBox: "0 0 66 66",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 33,
    cy: 9.3,
    rx: 13.4,
    ry: 5.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.6 16.8c0 1.4 1.1 2.7 3 3.7 2.5 1.3 6.2 2.1 10.3 2.1s7.9-.8 10.4-2.1c1.9-1 3-2.3 3-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.6 24.3c0 1.4 1.1 2.7 3 3.7 2.5 1.3 6.2 2.1 10.3 2.1s7.9-.8 10.4-2.1c1.9-1 3-2.3 3-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.4 31.8c0 3.3-6 5.9-13.4 5.9s-13.4-2.6-13.4-5.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.4 32v-7.4-7.5-7.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.6 9.3v22.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: ""
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5,
    cy: 49.4,
    rx: 8.4,
    ry: 3.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 54.2c0 .9.7 1.7 1.9 2.4 1.6.8 3.9 1.3 6.5 1.3s5-.5 6.5-1.3c1.2-.6 1.9-1.5 1.9-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 58.9c0 .9.7 1.7 1.9 2.4 1.6.8 3.9 1.3 6.5 1.3s5-.5 6.5-1.3c1.2-.6 1.9-1.5 1.9-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.9 59v-4.7-4.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 49.4v9.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: ""
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 33,
    cy: 49.4,
    rx: 8.4,
    ry: 3.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.6 54.2c0 .9.7 1.7 1.9 2.4 1.6.8 3.9 1.3 6.5 1.3s5-.5 6.5-1.3c1.2-.6 1.9-1.5 1.9-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.6 58.9c0 .9.7 1.7 1.9 2.4 1.6.8 3.9 1.3 6.5 1.3s5-.5 6.5-1.3c1.2-.6 1.9-1.5 1.9-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.4 59v-4.7-4.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.6 49.4v9.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: ""
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.5,
    cy: 49.4,
    rx: 8.4,
    ry: 3.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.1 54.2c0 .9.7 1.7 1.9 2.4 1.6.8 3.9 1.3 6.5 1.3s5-.5 6.5-1.3c1.2-.6 1.9-1.5 1.9-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.1 58.9c0 .9.7 1.7 1.9 2.4 1.6.8 3.9 1.3 6.5 1.3s5-.5 6.5-1.3c1.2-.6 1.9-1.5 1.9-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64 59v-4.7-4.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.1 49.4v9.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: ""
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m33 38.5v6.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m55 44.9v-16.6c0-2.6-2.1-4.8-4.8-4.8h-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 44.9v-16.6c0-2.6 2.1-4.8 4.8-4.8h2.5"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m55 8.4v8.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m11.5 8.4v8.3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReallot);
export default __webpack_public_path__ + "static/media/Reallot.bf9b3b5e28f1a09ec47d67cfcf9f7735.svg";
export { ForwardRef as ReactComponent };